import type { IButton2 } from '../../uiParts/buttons2'
import type { IItemTweener } from './itemTweeners'
import { l } from '../../lib/imports'
import { itemTweeners } from './itemTweeners-sidecar'
import { buttons2 } from '../../uiParts/buttons2-sidecar'

import type { INumSelector2 } from '../../uiParts/numSelectors2'
import { mathUtils } from '../../lib/mathUtils-sidecar'

export interface IMenuItem {
  button: IButton2 | null
  numSelector: INumSelector2 | null
  onHighlighted: () => void
  onActivated: () => void
}
export interface IMenu {
  items: IMenuItem[]
  selectedIdx: number
  x: number
  y: number
  tweens: IItemTweener[]
}

export const objs: IMenu[] = []
let _activeMenu: IMenu | null = null

export const setActiveMenu = (menu: IMenu | null) => {
  if (_activeMenu) {
    unhighlightAll(_activeMenu)
  }
  _activeMenu = menu
  if (_activeMenu) {
    unhighlightAll(_activeMenu)
  }
}

export const getIsInMenu = () => {
  return _activeMenu !== null
}

export const create = () => {
  let obj: IMenu = {
    items: [],
    selectedIdx: -1,
    x: 0,
    y: 0,
    tweens: [],
  }
  objs.push(obj)
  return obj
}

export const createMenuItem = (
  menu: IMenu,
  button: IButton2 | null,
  numSelector: INumSelector2 | null,
) => {
  let obj: IMenuItem = {
    button,
    numSelector,
    onHighlighted: () => {},
    onActivated: () => {},
  }
  menu.items.push(obj)
  return obj
}

export const setTweens = (
  menu: IMenu,
  isActive: boolean,
  isImmediate: boolean = false,
) => {
  l.forEach(menu.tweens, (c) => {
    itemTweeners.setState(c, isActive, isImmediate)
  })
}

export const updateAll = () => {
  objs.forEach((c) => {
    update(c)
  })
}
const update = (obj: IMenu) => {}

export const highlight = (idx: number) => {
  console.log('menu activate', idx)
  if (_activeMenu) {
    unhighlightAll(_activeMenu)

    if (_activeMenu.items.length > 0) {
      _activeMenu.selectedIdx = mathUtils.betterMod(
        idx,
        _activeMenu.items.length,
      )
      let item = _activeMenu.items[_activeMenu.selectedIdx]
      if (item.button) {
        buttons2.highlight(item.button)
      }
    }
  }
}

export const activate = () => {
  if (_activeMenu) {
    if (_activeMenu.items.length > 0 && _activeMenu.selectedIdx >= 0) {
      let item = _activeMenu.items[_activeMenu.selectedIdx]
      if (item.button) {
        buttons2.executeClick(item.button)
      }
    }
  }
}

export const handleGamepad = (keys: {
  menuUp: number
  menuDown: number
  menuActivate: number
}) => {
  if (_activeMenu) {
    if (keys.menuActivate === 1) {
      activate()
    }
    if (keys.menuUp === 1) {
      highlight(_activeMenu.selectedIdx - 1)
    }
    if (keys.menuDown === 1) {
      highlight(_activeMenu.selectedIdx + 1)
    }

    return true
  }
  return false
}

export const handleKeydown = (code: string) => {
  // console.log('menu code', code)
  console.log('menu handle keydown', code, _activeMenu)
  if (_activeMenu) {
    if (code === 'ArrowUp') {
      highlight(_activeMenu.selectedIdx - 1)
      return true
    }
    if (code === 'ArrowDown') {
      highlight(_activeMenu.selectedIdx + 1)
      return true
    }
    if (code === 'Enter') {
      activate()
      return true
    }
  }

  return false
}
export const handleKeyup = (code: string) => {
  return false
}

export const unhighlightAll = (obj: IMenu) => {
  l.forEach(obj.items, (c) => {
    if (c.button) {
      buttons2.unhighlight(c.button)
    }
    obj.selectedIdx = -1
  })
}
